import React, { useEffect } from 'react';
import './Hero.scss';
import gsap from 'gsap';
import { TextPlugin } from 'gsap/all';
import heroBg from '../../assets/img/hero-bg.png';
import { FiChevronsDown } from 'react-icons/fi';

gsap.registerPlugin(TextPlugin);

function Hero() {
  const nicks = ['Finn', 'Ahmed', 'Ali'];

  useEffect(() => {
    gsap.from('.text h1', {
      duration: 1,
      ease: 'power4.inOut',
      y: '-7vh',
    });

    gsap.to('.text h1', {
      duration: 2.5,
      text: 'Hello World',
      ease: 'none',
      delay: 0.7,
      repeat: -1,
      yoyo: true,
      repeatDelay: 1,
    });

    gsap.to('.text span', {
      duration: 0.9,
      opacity: 0,
      ease: 'power2.inOut',
      repeat: -1,
    });

    gsap.from('.text p', {
      duration: 1.2,
      delay: 1.3,
      ease: 'power4.inOut',
      y: '8vh',
      stagger: {
        amount: 1.2,
      },
    });

    // let masterTL = gsap.timeline({ repeat: -1 });

    // nicks.map((nick) => {
    //   let TL = gsap.timeline({ yoyo: true });
    //   TL.to('.hero h4', {
    //     duration: 2,
    //     text: nick,
    //   });
    //   masterTL.add(TL);
    // });
  }, []);

  return (
    <section className="hero">
      <img src={heroBg} alt="background" />
      <div className="text">
        <h1> H </h1>
        <span>|</span>

        <p>My name is Finn Ahamed</p>
        <p>An aspiring Front-end Developer</p>
        {/* <h4></h4> */}
      </div>

      <div className="actionBtn">
        <button onClick={() => (window.location.href = '#slightestMe')}>
          Know me better
        </button>
      </div>
      <a href="#offer">
        <FiChevronsDown className="downBtn" />
      </a>
    </section>
  );
}

export default Hero;
